export const heatmap = {
    cell: {
        style: {
            shape: "square",
            fillOpacity: 1
        }
    },
    cellBackground: {
        visible: !1
    }
};
//# sourceMappingURL=heatmap.js.map
